import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
// prettier-ignore
export default {
	...zhLocale,
	// 基础
	add: '添加',
	edit: '编辑',
	delete: '删除',
	cancel: '取消',
	batch_edit: '批量编辑',
	title: '标题',
	desc: '描述',
	path: '路径',
	icon: '图标',
	permission: '权限',
	login: '登录',
	logout: '退出登录',
	date: '日期',
	download: '下载',
	submit: '提交',
	reset: '重置',
	sort: '排序',
	sure: '是',
	negate: '否',
	settings: '个人设置',
	component: '组件',
	search: '搜索',
	export: '导出',
	more: '更多',
	retract: '收起',
	download_table: '下载表格',
	confirm: '确定',
	role: '身份',
	email: '邮箱',
	name: '名称',
	account: '账户',
	all: '所有',
	type: '类型',
	time: '时间',
	handle: '操作',
	password: '密码',
	tips: '提示',
	past: '返回旧版',
	cover: '封面',
	status: '状态',
	add_package: '添加套餐',
	save: '保存',
	ordering: '订餐',
	branch_cancel_ordering: '批量取消订餐',
	branch_ordering: '批量订餐',
	// login模块
	module_login: {
		zhaonaxue_admin: '管理平台',
		title: '校园管理平台',
		username: '请输入用户名',
		password: '请输入密码'
	},

	// cofigure模块
	module_configure: {
		parent_menu: '父级菜单',
		navigation: '导航菜单',
		enable: '启用',
		absolute: '绝对地址',
		url: '后台地址',
		placeholder_title: '请输入标题（不超过 24 个字符）',
		placeholder_parent: '父级菜单',
		placeholder_desc: '描述（不超过 100 个字符）',
		placeholder_path: '请输入路径',
		placeholder_icon: '请填写图标名称',
		placeholder_sort: '排序（请填写数字）',
		placeholder_permission: '请选择权限',
		placeholder_url: '请输入后台地址',
		placeholder_component: '请输入组件名',
		warn_title_empty: '标题不能为空',
		warn_title_limit: '长度最多为 24 个字符',
		warn_desc_empty: '描述不能为空',
		warn_desc_limit: '长度最多为 100 个字符',
		warn_path_empty: '路径不能为空',
		warn_sort_empty: '排序不能为空',
		warn_sort_limit: '排序必须为数字值',
		warn_navigation_empty: '请选择是否为导航菜单',
		warn_absolute_empty: '请选择是否为绝对地址',
		warn_url_empty: 'url不能为空',
		warn_component_empty: '组件名不能为空'
	},
	// settings模块
	module_settings: {
		origin_password: '原密码',
		update: '更新资料',
		change_password: '修改密码',
		new_password: '新密码',
		comfirm_password: '确认密码'
	},
	// usage模块
	module_usage: {
		all: '全部',
		explain: '功能说明',
		guide: '新手引导',
		update: '近期更新',
		placeholder: '请输入功能名称、标题、关键字',
		details: '查看详情'
	},
	// 跟tab有关
	home: '校园管理平台',
	school_manager: '学校信息管理',
	school: '学校管理',
	staff: '职工管理',
	parent: '家长管理',
	student: '学生管理',
	class: '班级管理',
	course: '课程管理',
	subject: '科目管理',
	user_manager: '用户管理',
	daily_manager: '日常运营管理',
	product_manager: '产品管理',
	payment_manager: '缴费管理',
	service_manager: '服务管理',
	device_manager: '设备管理',
	configure_manager: '配置管理',
	configure_routes: '路由配置',
	configure_menu: '菜单管理',
	monitor_manager: '监控管理',
	lab: '实验室',
	consumption_system: '消费系统',
	consumption_statistics: '统计报表',
	consumption_billFlow: '流水记录',
	consumption_device: '设备与限制',
	consumption_account: '账户管理',
	consumption_user: '用户管理',
	bug: 'Bug收集',
	bug_test: 'Bug测试',
	bug_view: 'Bug展示',
	usage_desc: '首页',
	usage_details: '详情页',
	auth: '用户与权限',
	auth_permission: '权限管理',
	auth_role: '角色管理',
	product_operation: '产品运营',
	knowledge_payment: '知识付费',
	live_room: '直播间',
	members: '开通会员',
	// 跟动作有关
	close_all: '关闭所有',
	close_others: '关闭其他',

	// 跟tools_bar有关
	usage: '帮助中心',
	full_screen: '全屏',
	exit_screen: '退出全屏',
	change_role: '切换身份',
	// home模块
	module_home: {
		help: '帮助中心',
		prod: '正式运营',
		pre: '孵化中',
		dev: '研发中',
		update: '近期更新',
		guide: '新手引导',
		desc: '功能说明',
		common: '常用功能'
	},
	// 消费系统
	module_consume: {
		consume_statistics: '消费统计',
		cash_statistics: '现金统计',
		eat_statistics: '就餐统计',
		meal_times_statistics: '餐次',
		set_meal_statistics: '套餐',
		meal_set_statistics: '套餐设置',
		meal_time_set_statistics: '就餐时间设置',
		dining_rule_statistics: '就餐规则',
		ordering_by_name: '通过姓名订餐',
		ordering_by_id: '通过学生标识订餐',
		meal_time_statistics: '就餐时间',
		dining_state_statistics: '就餐状态',
		day_statistics: '本日统计',
		week_statistics: '本周统计',
		month_statistics: '本月统计',
		consumption: '消费',
		top_up: '现金充值',
		yuan: '元',
		statistics_way: '统计方式',
		date_statistics: '按日期统计',
		meal_statistics: '按餐次统计',
		time_statistics: '按时段统计',
		merchant_statistics: '按商户统计',
		device_statistics: '按设备统计',
		user_statistics: '按用户统计',
		operator_statistics: '按操作人员统计',
		set_time_slot: '设置消费时段',
		set_statistics_range: '设置统计范围',
		setting_way: '设置方式',
		business_set: '按商户设置',
		device_set: '按设备设置',
		device_need_statistics: '需要统计的设备',
		merchant_need_statistics: '需要统计的商户',
		device_not_statistics: '不需要统计的设备',
		merchant_not_statistics: '不需要统计的商户',
		merchant_name: '请输入商户名称',
		device_name: '请输入设备名称',
		morning: '早上',
		noon: '中午',
		afternoon: '下午',
		evening: '晚上',
		recharge_statistics: '充值统计',
		day_recharge: '本日充值',
		week_recharge: '本周充值',
		month_recharge: '本月充值',
		recharge_amount: '充值金额'
	},
	// 筛选项
	module_selectors: {
		all: '全部',
		allSchool: '请选择学校',
		selectSchool: '请选择学校',
		to: '至',
		beginning: '开始日期',
		ending: '结束日期',
		daily_statistics: '按日统计',
		weekly_statistics: '按周统计',
		monthly_statistics: '按月统计',
		teacher: '职工',
		student: '学生',
		parent: '家长',
		account_balance: '账户余额',
		alipay_withholding: '支付宝代扣',
		regular_account: '常规账户',
		allowance_account: '补助账户',
		default_merchat: '默认商户',
		school: '选择学校',
		date: '选择日期',
		time: '选择时间范围',
		time_unit: '时间单位',
		user_type: '用户类型',
		select_device: '选择设备',
		class: '选择班级',
		merchant: '选择商户',
		device: '选择设备',
		consume_type: '消费方式',
		account_type: '账户类型',
		operator: '操作人员',
		fund_custody: '资金存管',
		search_user: '搜索用户',
		search_input: '请输入用户名或卡号',
		cash: '现金',
		wechat: '微信',
		alipay: '支付宝',
		grade: '选择年级',
		rule: '规则名称',
		rule_name: '请输入规则名称',
		start_time: '开始时间',
		end_time: '结束时间',
		identify_state: '识别状态',
		acquaintance_degree: '相似度',
		duplicate_removal: '人员去重',
		studentID_sort: '按学生ID排序',
		device_type: '设备类型',
		application_system: '应用系统'
	},
	// 表格
	module_table: {
		date: '日期',
		name: '姓名',
		class: '班级',
		grade: '年级',
		user: '用户',
		// 消费系统的表格
		device: '设备',
		merchant: '商户',
		consume_income_statistics: '消费收入统计',
		consume_yuan: '消费(元)',
		consume_time: '消费(次)',
		refund_expend_statistics: '退款支出统计',
		refund_yuan: '退款(元)',
		refunt_time: '退款(次)',
		consume_balance: '消费收支结余(元)',
		operation: '操作',
		details: '详情',
		cash_income_statistics: '现金收入统计',
		cash_expend_statistics: '现金支出统计',
		topUp_yuan: '充值(元)',
		topUp_time: '充值(次)',
		cash_withdrawal_yuan: '取现(元)',
		cash_withdrawal_time: '取现(次)',
		withdraw_yuan: '退卡(元)',
		withdraw_time: '退卡(次)',
		cash_expend_all: '现金支出合计(元)',
		cash_balance: '现金收支结余(元)',
		device_info: '设备信息',
		location: '当前所处地点',
		business: '当前所属商户',
		user_info: '用户信息',
		card_num: '卡号',
		morning_yuan: '早上消费(元)',
		noon_yuan: '中午消费(元)',
		afternoon_yuan: '下午消费(元)',
		evening_yuan: '晚上消费(元)',
		total_yuan: '消费合计(元)',
		total_time: '消费合计(次)',
		// 刷脸就餐
		set_meal_name: '套餐名称',
		set_meal_num: '订餐人数',
		dinner_times: '餐次',
		dinner_num: '就餐人次',
		on_time_num: '按时就餐人次',
		late_num: '迟到就餐人次',
		no_dinner_num: '未就餐人次',
		ordering_num: '订餐人次',
		system_id: '系统id',
		meal_time: '就餐时间',
		dining_state: '就餐状态',
		dining_type: '就餐方式',
		face_database_img: '人脸库图片',
		face_swiping_img: '刷脸图片',
		weixin_income_statistics: '微信收入统计'
	},
	// auth模块
	module_auth: {
		permission_placeholder: '请搜索权限名称',
		role_placeholder: '请搜索角色名称',
		authorize: '授权管理',
		configure: '权限配置',
		update: '修改',
		delete: '删除',
		add_permission: '添加权限',
		add_role: '添加角色',
		update_permission: '修改权限',
		update_role: '修改身份',
		filter_placeholder: '输入关键字进行过滤',
		permission_parent_name: '父权限',
		role_parent_name: '父角色',
		permission_name: '权限名称',
		role_name: '角色名称',
		placeholder: '请输入内容',
		delete_message: '确定删除该权限？',
		cancle_message: '已取消删除'
	},
	module_knowledge_payment: {
		school: '学校',
		agent: '代理商',
		all: '全部',
		list: '学校列表',
		school_name: '学校名称',
		school_number: '学校人数',
		placeholder: '请输入关键词',
		free: '免费试听',
		charge: '付费专区',
		create: '新建直播间',
		update: '修改直播间',
		name: '课程名称',
		desc: '简介',
		coupon: '优惠券链接',
		url: '课程链接',
		cover: '课程封面',
		name_placeholder: '请输入课程名称（不超过30个字）',
		desc_placeholder: '请输入课程简介（不超过30个字）',
		url_placeholder: '请输入课程链接',
		coupon_placeholder: '请输入优惠券链接',
		cover_message: '请上传封面',
		name_message: '请输入课程名称',
		desc_message: '请输入课程简介',
		url_message: '请输入课程链接',
		coupon_message: '请输入优惠券链接',
		name_message_max: '课程名称不超过30个字',
		desc_message_max: '课程简介不超过30个字',
		url_message_max: '课程链接不超过300个字',
		coupon_message_max: '优惠券链接不超过300个字'
	},
	// 危险区域
	module_dangerous_zone: {
		dangerous_zone: '危险区域',
		dangerous_record: '历史记录',
		dangerous_manage: '设置管理'
	},
	'学校名称：': '学校名称：',
	'菜单管理': '菜单管理',
	'照片名称': '照片名称',
	'完成': '完成',
	'订餐人次': '订餐人次',
	'用户管理': '用户管理',
	'考试成功！': '考试成功！',
	'排序不能为空': '排序不能为空',
	'按操作人员统计': '按操作人员统计',
	'人脸识别已开启': '人脸识别已开启',
	'设备与限制': '设备与限制',
	'温馨提示': '温馨提示',
	'请先输入分账商户列表的商户号': '请先输入分账商户列表的商户号',
	'暂无班级数据': '暂无班级数据',
	'录入状态': '录入状态',
	'操作者': '操作者',
	'登录': '登录',
	'默认商户': '默认商户',
	'按餐次统计': '按餐次统计',
	'父级菜单': '父级菜单',
	'添加更多家长': '添加更多家长',
	'缴费管理': '缴费管理',
	'交费状态': '交费状态',
	'是否开启收费': '是否开启收费',
	'用户信息': '用户信息',
	'删除门禁': '删除门禁',
	'孩子所属姓名': '孩子所属姓名',
	'后台地址': '后台地址',
	'选择年级': '选择年级',
	'删除': '删除',
	'授权管理': '授权管理',
	'按时就餐人次': '按时就餐人次',
	'班级': '班级',
	'无数据': '无数据',
	'充值统计': '充值统计',
	'请先输入商户号': '请先输入商户号',
	'重新下载': '重新下载',
	'收集': '收集',
	'导入失败，请修改后重新上传': '导入失败，请修改后重新上传',
	'下载人脸照片采集说明': '下载人脸照片采集说明',
	'学校管理': '学校管理',
	'科目名称：': '科目名称：',
	'批量导入历史': '批量导入历史',
	'人脸识别闸门2代：104及其以上版本，低版本的请先升级': '人脸识别闸门2代：104及其以上版本，低版本的请先升级',
	'请先输入分账商户列表的商户名称': '请先输入分账商户列表的商户名称',
	'识别时间': '识别时间',
	'确认提交后，系统将生成账单的支付信息，并修改账单的状态，是否继续执行': '确认提交后，系统将生成账单的支付信息，并修改账单的状态，是否继续执行',
	'校园缴费表格模板': '校园缴费表格模板',
	'关联公众号：': '关联公众号：',
	'批量录入说明': '批量录入说明',
	'不参与': '不参与',
	'当前账单已取消收费，无法进行催交': '当前账单已取消收费，无法进行催交',
	'上传完成': '上传完成',
	'的操作': '的操作',
	'三次识别阈值': '三次识别阈值',
	'家长': '家长',
	'分账状态': '分账状态',
	'上传人脸excel文件失败': '上传人脸excel文件失败',
	'的生效时段开始时间必选小于结束时间': '的生效时段开始时间必选小于结束时间',
	'说明': '说明',
	'商户单号': '商户单号',
	'出错了：': '出错了：',
	'设置成功': '设置成功',
	'已识别（BD2）': '已识别（BD2）',
	'退款支出统计': '退款支出统计',
	'服务状态（点击修改状态）': '服务状态（点击修改状态）',
	'历史记录': '历史记录',
	'校园缴费v1.2_后台_获取商户最大分账比例接口失败': '校园缴费v1.2_后台_获取商户最大分账比例接口失败',
	'交费状态`': '交费状态`',
	'全部分类': '全部分类',
	'学籍状态': '学籍状态',
	'确认密码': '确认密码',
	'请输入课程简介（不超过30个字）': '请输入课程简介（不超过30个字）',
	'更多': '更多',
	'请输入手机号': '请输入手机号',
	'已识别（BD1）': '已识别（BD1）',
	'详情页': '详情页',
	'激活学校收费接口失败': '激活学校收费接口失败',
	'请先点击此处': '请先点击此处',
	'请输入二次识别活体阈值': '请输入二次识别活体阈值',
	'初始化': '初始化',
	'常用功能': '常用功能',
	'请输入课程名称（不超过30个字）': '请输入课程名称（不超过30个字）',
	'新建直播间': '新建直播间',
	'消费': '消费',
	'组件': '组件',
	'请先选择发布人': '请先选择发布人',
	'已开启：': '已开启：',
	'班级管理': '班级管理',
	'图标': '图标',
	'学校id': '学校id',
	'规则名称': '规则名称',
	'已批量配置成功': '已批量配置成功',
	'延时时间': '延时时间',
	'请输入学生姓名': '请输入学生姓名',
	'现金收入统计': '现金收入统计',
	'正在添加家长,请勿重复操作!': '正在添加家长,请勿重复操作!',
	'邮箱': '邮箱',
	'新手引导': '新手引导',
	'未录入': '未录入',
	'重新上传': '重新上传',
	'已过期': '已过期',
	'已删除': '已删除',
	'获取规则详情': '获取规则详情',
	'确定': '确定',
	'当前号码存在以下订阅服务': '当前号码存在以下订阅服务',
	'催交成功，未交费的家长将收到推送提醒': '催交成功，未交费的家长将收到推送提醒',
	'账单已截止，不可操作不参与': '账单已截止，不可操作不参与',
	'选择日期时间': '选择日期时间',
	'充值金额': '充值金额',
	'模板背景': '模板背景',
	'发布人：': '发布人：',
	'请输入识别阈值': '请输入识别阈值',
	'数据同步中，稍等片刻点击刷新查看同步情况': '数据同步中，稍等片刻点击刷新查看同步情况',
	'使用中': '使用中',
	'补助账户': '补助账户',
	'获取配置失败,请刷新重试': '获取配置失败,请刷新重试',
	'金额': '金额',
	'请输入功能名称、标题、关键字': '请输入功能名称、标题、关键字',
	'查看批量录入历史': '查看批量录入历史',
	'永久': '永久',
	'退出登录': '退出登录',
	'未分账': '未分账',
	'请先选择代理商': '请先选择代理商',
	'请选择亲属关系': '请选择亲属关系',
	'孩子姓名': '孩子姓名',
	'直播间': '直播间',
	'上传名单': '上传名单',
	'请先输入通知标题': '请先输入通知标题',
	'人脸识别闸门2代:70及其以上版本,低版本的请先升级': '人脸识别闸门2代:70及其以上版本,低版本的请先升级',
	'创建收款码失败': '创建收款码失败',
	'请假放行': '请假放行',
	'套餐设置': '套餐设置',
	'登记信息：': '登记信息：',
	'正式运营': '正式运营',
	'请选择学生标识': '请选择学生标识',
	'就餐时间设置': '就餐时间设置',
	'发布成绩': '发布成绩',
	'学校未开通微信商户，请联系运营人员开通': '学校未开通微信商户，请联系运营人员开通',
	'按周统计': '按周统计',
	'请选择适用设备': '请选择适用设备',
	'创建账单成功': '创建账单成功',
	'同步中': '同步中',
	'未选择': '未选择',
	'统计报表': '统计报表',
	'无需录入': '无需录入',
	'元': '元',
	'退卡(元)': '退卡(元)',
	'用户与权限': '用户与权限',
	'请输入校园卡号': '请输入校园卡号',
	'确认开始批量录入': '确认开始批量录入',
	'系统': '系统',
	'分账状态：': '分账状态：',
	'请输入token': '请输入token',
	'付费专区': '付费专区',
	'允许进出': '允许进出',
	'这是': '这是',
	'人脸识别闸门：93及其以上版本，低版本的请先升级': '人脸识别闸门：93及其以上版本，低版本的请先升级',
	'排序（请填写数字）': '排序（请填写数字）',
	'上传图片失败': '上传图片失败',
	'请输入播报名称': '请输入播报名称',
	'孵化中': '孵化中',
	'六': '六',
	'请选择用户类型': '请选择用户类型',
	'抓拍图片': '抓拍图片',
	'学校': '学校',
	'共': '共',
	'未发布': '未发布',
	'处理删除': '处理删除',
	'关': '关',
	'女': '女',
	'晚上消费(元)': '晚上消费(元)',
	'选择用户类型': '选择用户类型',
	'不能为空': '不能为空',
	'线下支付': '线下支付',
	'标题': '标题',
	'请输入路径': '请输入路径',
	'个人设置': '个人设置',
	'考试名称已超出限定的20个字数': '考试名称已超出限定的20个字数',
	'首页': '首页',
	'按设备统计': '按设备统计',
	'详情': '详情',
	'未设置': '未设置',
	'无匹配数据': '无匹配数据',
	'鼠标移动到此处查看目前支持的设备和版本': '鼠标移动到此处查看目前支持的设备和版本',
	'查找不到设备？鼠标移到此处查看目前支持的设备和版本': '查找不到设备？鼠标移到此处查看目前支持的设备和版本',
	'不生效日期': '不生效日期',
	'收费名称': '收费名称',
	'确定移除 ': '确定移除 ',
	'充值(次)': '充值(次)',
	'优惠券链接不超过300个字': '优惠券链接不超过300个字',
	'学校信息管理': '学校信息管理',
	'返回': '返回',
	'当前仅支持docx、xlsx、xls、ppt、pptx、mp4文件的上传': '当前仅支持docx、xlsx、xls、ppt、pptx、mp4文件的上传',
	'正在同步': '正在同步',
	'应用系统': '应用系统',
	'取消时长:': '取消时长:',
	'请先输入商户名称': '请先输入商户名称',
	'存在以下订阅服务，暂不允许删除，若要删除，请先取消订阅，并进行退款': '存在以下订阅服务，暂不允许删除，若要删除，请先取消订阅，并进行退款',
	'收款码名称不能为空': '收款码名称不能为空',
	'仅刷卡闸门设备有分进和出两个方向，其他设备中': '仅刷卡闸门设备有分进和出两个方向，其他设备中',
	'消费收入统计': '消费收入统计',
	'创建账单': '创建账单',
	'导入数据': '导入数据',
	'删除中...': '删除中...',
	'关闭成功': '关闭成功',
	'科目管理': '科目管理',
	'收款码名称：': '收款码名称：',
	'添加考试': '添加考试',
	'对象范围：': '对象范围：',
	'请输入优惠券链接': '请输入优惠券链接',
	'请输入商户名称': '请输入商户名称',
	'现金充值': '现金充值',
	'订餐': '订餐',
	'账户': '账户',
	'请输入最短未识别间隔（分钟）': '请输入最短未识别间隔（分钟）',
	'当前学生': '当前学生',
	'请上传封面': '请上传封面',
	'学生姓名最大长度为50个字': '学生姓名最大长度为50个字',
	'就餐时间': '就餐时间',
	'上传文件不能为空': '上传文件不能为空',
	'请上传人脸照片匹配表': '请上传人脸照片匹配表',
	'秒': '秒',
	'退出全屏': '退出全屏',
	'禁止通行': '禁止通行',
	'分账商户号': '分账商户号',
	'校园缴费表格模板.xlsx': '校园缴费表格模板.xlsx',
	'在读': '在读',
	'设备类型': '设备类型',
	'近期更新': '近期更新',
	'确定要删除': '确定要删除',
	'获取成绩科目列表失败, 请刷新重试': '获取成绩科目列表失败, 请刷新重试',
	'系统繁忙，请重新上传': '系统繁忙，请重新上传',
	'上传人脸照片压缩文件,仅支持zip格式': '上传人脸照片压缩文件,仅支持zip格式',
	'腾讯': '腾讯',
	'删除科目失败-else, 请刷新重试': '删除科目失败-else, 请刷新重试',
	'关系': '关系',
	'已识别': '已识别',
	'收费名称不超过50个字': '收费名称不超过50个字',
	'至': '至',
	'此操作将永久删除该学生, 是否继续?': '此操作将永久删除该学生, 是否继续?',
	'操作成功': '操作成功',
	'月考': '月考',
	'本日充值': '本日充值',
	'已识别（盒）': '已识别（盒）',
	'二维码收费': '二维码收费',
	'用户': '用户',
	'未绑定': '未绑定',
	'请选择考试科目': '请选择考试科目',
	'服务器繁忙，请刷新重试！': '服务器繁忙，请刷新重试！',
	'数据上传中': '数据上传中',
	'彩色小摆闸：21及其以上版本，低版本的请先升级': '彩色小摆闸：21及其以上版本，低版本的请先升级',
	'最短未识别间隔（分钟）': '最短未识别间隔（分钟）',
	'周六': '周六',
	'无需激活': '无需激活',
	'分账详情': '分账详情',
	'删除科目失败-catch, 请刷新重试': '删除科目失败-catch, 请刷新重试',
	'编辑模板': '编辑模板',
	'添加成功': '添加成功',
	'中午消费(元)': '中午消费(元)',
	'家长数：': '家长数：',
	'添加套餐': '添加套餐',
	'请输入姓名': '请输入姓名',
	'商品信息': '商品信息',
	'全部家长': '全部家长',
	'请先选择发布范围': '请先选择发布范围',
	'孩子所属年级': '孩子所属年级',
	'删除学生': '删除学生',
	'的生效时段': '的生效时段',
	'有效期': '有效期',
	'登记类型': '登记类型',
	'导出结果': '导出结果',
	'若选择“必交”，则家长必须支付后才能完成账单': '若选择“必交”，则家长必须支付后才能完成账单',
	'输入抓拍图片链接': '输入抓拍图片链接',
	'考试时间': '考试时间',
	'人脸识别闸门1代：时段内设备暂停更新所有数据；人脸识别闸门2代：时段内设备仅暂停更新人脸数据。': '人脸识别闸门1代：时段内设备暂停更新所有数据；人脸识别闸门2代：时段内设备仅暂停更新人脸数据。',
	'门禁规则添加成功': '门禁规则添加成功',
	'三次识别': '三次识别',
	'生效时间: ': '生效时间: ',
	'当前账单已截止收费，无法进行催交': '当前账单已截止收费，无法进行催交',
	'未划分年级': '未划分年级',
	'一次只能上传一个excel文件，请删除再上传': '一次只能上传一个excel文件，请删除再上传',
	'恢复激活年限:': '恢复激活年限:',
	'刷新': '刷新',
	'请先选择学校': '请先选择学校',
	'消费系统': '消费系统',
	'未识别': '未识别',
	'已识别（TX1）': '已识别（TX1）',
	'导入成功，': '导入成功，',
	'接口异常，请稍后重试': '接口异常，请稍后重试',
	'当前所处地点': '当前所处地点',
	'课程管理': '课程管理',
	'默认设置': '默认设置',
	'请输入考试名称': '请输入考试名称',
	'获取成绩科目列表失败-catch, 请刷新重试': '获取成绩科目列表失败-catch, 请刷新重试',
	'微信收入统计': '微信收入统计',
	'下载模板': '下载模板',
	'搜索用户': '搜索用户',
	'监控管理': '监控管理',
	'人脸识别已关闭': '人脸识别已关闭',
	'明细': '明细',
	'仅支持docx、xlsx、xls、ppt、pptx、mp4文件上传,请重新选择': '仅支持docx、xlsx、xls、ppt、pptx、mp4文件上传,请重新选择',
	'考试科目:': '考试科目:',
	'已录入:': '已录入:',
	'用户类型': '用户类型',
	'同步家长数据': '同步家长数据',
	'类型': '类型',
	'生效中': '生效中',
	'成功': '成功',
	'条数据同步成功，': '条数据同步成功，',
	'请选择考试时间': '请选择考试时间',
	'设置管理': '设置管理',
	'一键催交': '一键催交',
	'文本': '文本',
	'请输入正确的学生卡': '请输入正确的学生卡',
	'学号：': '学号：',
	'学生：全部学生': '学生：全部学生',
	'套餐': '套餐',
	'年级班级': '年级班级',
	'规则结束日期': '规则结束日期',
	'免费试听': '免费试听',
	'结果备注': '结果备注',
	'校园卡号：': '校园卡号：',
	'同步年级班级数据': '同步年级班级数据',
	'职工管理': '职工管理',
	'请上传格式为xlsx的文件': '请上传格式为xlsx的文件',
	'获取考试详情失败, 请刷新重试': '获取考试详情失败, 请刷新重试',
	'考试科目': '考试科目',
	'通过学生标识订餐': '通过学生标识订餐',
	'请选择学校': '请选择学校',
	'取消激活': '取消激活',
	'运营人员': '运营人员',
	'分账关系': '分账关系',
	'标题不能为空': '标题不能为空',
	'部分交费': '部分交费',
	'腾讯库同步': '腾讯库同步',
	'中午': '中午',
	'请输入大于0的整数': '请输入大于0的整数',
	'设置统计范围': '设置统计范围',
	'截止日期不能为空': '截止日期不能为空',
	'人脸库同步期间，人脸识别功能不可用。你确定要同步？': '人脸库同步期间，人脸识别功能不可用。你确定要同步？',
	'请勿重复操作': '请勿重复操作',
	'请添加模板封面': '请添加模板封面',
	'学校商户关闭分账状态失败': '学校商户关闭分账状态失败',
	'支持扩展名：.xls .xlsx': '支持扩展名：.xls .xlsx',
	'帮助中心': '帮助中心',
	'模板标题': '模板标题',
	'导入结果': '导入结果',
	'批量编辑': '批量编辑',
	'支付信息': '支付信息',
	'正在导出表格，请勿重复操作': '正在导出表格，请勿重复操作',
	'人脸录入时间': '人脸录入时间',
	'职工：': '职工：',
	'职工姓名': '职工姓名',
	'发布考试失败, 请刷新重试': '发布考试失败, 请刷新重试',
	'关闭': '关闭',
	'管理平台': '管理平台',
	'请搜索权限名称': '请搜索权限名称',
	'职工总数': '职工总数',
	'名单收费': '名单收费',
	'请先输入分账商户列表的分账比例': '请先输入分账商户列表的分账比例',
	'门禁规则': '门禁规则',
	'二次识别阈值不能为0': '二次识别阈值不能为0',
	'三、填写人脸信息匹配表要求': '三、填写人脸信息匹配表要求',
	'下载': '下载',
	'高': '高',
	'活体检测': '活体检测',
	'添加角色': '添加角色',
	'已暂停': '已暂停',
	'选择算法': '选择算法',
	'期中': '期中',
	'添加科目失败-catch, 请刷新重试': '添加科目失败-catch, 请刷新重试',
	'录入照片': '录入照片',
	'成绩？': '成绩？',
	'人脸库同步提醒': '人脸库同步提醒',
	'需要统计的设备': '需要统计的设备',
	'已失败': '已失败',
	'一次识别阈值必须大于0': '一次识别阈值必须大于0',
	'导入失败，你可以下载导入失败的信息表，修改后重新上传': '导入失败，你可以下载导入失败的信息表，修改后重新上传',
	'导出数据': '导出数据',
	'本日统计': '本日统计',
	'查看详情': '查看详情',
	'编辑家长': '编辑家长',
	'批量取消订餐': '批量取消订餐',
	'保 存': '保 存',
	'适用日期': '适用日期',
	'上传视频不能大于100MB,请重新选择': '上传视频不能大于100MB,请重新选择',
	'分账商户：': '分账商户：',
	'晚上': '晚上',
	'以下用户的人脸同步到腾讯库失败。为不影响人脸识别，请通知对应用户重新录入人脸': '以下用户的人脸同步到腾讯库失败。为不影响人脸识别，请通知对应用户重新录入人脸',
	'返回旧版': '返回旧版',
	'消费统计': '消费统计',
	'支付账单': '支付账单',
	'修改': '修改',
	'添加模板': '添加模板',
	'重复周期': '重复周期',
	'获取考试列表失败, 请刷新重试': '获取考试列表失败, 请刷新重试',
	'按日统计': '按日统计',
	'请选择是否为绝对地址': '请选择是否为绝对地址',
	'消费方式': '消费方式',
	'鼠标移到此处查看支持的设备和版本': '鼠标移到此处查看支持的设备和版本',
	'获取导出数据失败，请刷新重试': '获取导出数据失败，请刷新重试',
	'请输入大于0且小于等于350的整数': '请输入大于0且小于等于350的整数',
	'选择日期': '选择日期',
	'提 交': '提 交',
	'添加校园卡': '添加校园卡',
	'上传人脸照片压缩包': '上传人脸照片压缩包',
	'更新`': '更新`',
	'按用户统计': '按用户统计',
	'确定停止后，当前账单将停止收费，家长无法完成支付，已支付的数据系统将保留，是否继续执行': '确定停止后，当前账单将停止收费，家长无法完成支付，已支付的数据系统将保留，是否继续执行',
	'确认删除该条模板?': '确认删除该条模板?',
	'编辑': '编辑',
	'长度最多为 100 个字符': '长度最多为 100 个字符',
	'考试人数:': '考试人数:',
	'校园管理平台': '校园管理平台',
	'职工：全部职工': '职工：全部职工',
	'消费(次)': '消费(次)',
	'简介': '简介',
	'识别记录': '识别记录',
	'发布中...': '发布中...',
	'选择商户': '选择商户',
	'允许通行': '允许通行',
	'永久有效': '永久有效',
	'请先填写通知内容': '请先填写通知内容',
	'等': '等',
	'若选择“自愿”，则家长可以选择“不参与”，即完成该账单': '若选择“自愿”，则家长可以选择“不参与”，即完成该账单',
	'此操作将删除该家长, 是否继续?': '此操作将删除该家长, 是否继续?',
	'调整收费时间': '调整收费时间',
	'修改考试失败, 请刷新重试': '修改考试失败, 请刷新重试',
	'考勤': '考勤',
	'描述不能为空': '描述不能为空',
	'添加分账商户': '添加分账商户',
	'微信绑定情况': '微信绑定情况',
	'保存成功': '保存成功',
	'统计方式': '统计方式',
	'学籍状态：': '学籍状态：',
	'请输入用户名或卡号': '请输入用户名或卡号',
	'考试名称:': '考试名称:',
	'设置': '设置',
	'请输入课程简介': '请输入课程简介',
	'请选择参加考试的班级': '请选择参加考试的班级',
	'需要统计的商户': '需要统计的商户',
	'资金存管': '资金存管',
	'迟到就餐人次': '迟到就餐人次',
	'添加科目名': '添加科目名',
	'催交': '催交',
	'设置学校收费接口失败': '设置学校收费接口失败',
	'课程封面': '课程封面',
	'解除绑定': '解除绑定',
	'考试名称': '考试名称',
	'本周充值': '本周充值',
	'基础信息': '基础信息',
	'上传人脸zip文件失败': '上传人脸zip文件失败',
	'请输入app_id': '请输入app_id',
	'学生总数': '学生总数',
	'确认后，账单状态将修改为“未支付”，学生家长需完成账单的支付，是否继续执行': '确认后，账单状态将修改为“未支付”，学生家长需完成账单的支付，是否继续执行',
	'撤销支付信息': '撤销支付信息',
	'就餐方式': '就餐方式',
	'请选择班级': '请选择班级',
	'学生标识': '学生标识',
	'开启成功': '开启成功',
	'封面': '封面',
	'上传文件': '上传文件',
	'路径不能为空': '路径不能为空',
	'删除成功!': '删除成功!',
	'删除失败，请重试': '删除失败，请重试',
	'后门': '后门',
	'人脸照片匹配表(职工)': '人脸照片匹配表(职工)',
	'描述（不超过 100 个字符）': '描述（不超过 100 个字符）',
	'学生姓名': '学生姓名',
	'禁止进出': '禁止进出',
	'分账金额': '分账金额',
	'确定删除该权限': '确定删除该权限',
	'背景颜色': '背景颜色',
	'请输入学号': '请输入学号',
	'设备信息': '设备信息',
	'发布范围': '发布范围',
	'学生信息': '学生信息',
	'请输入组件名': '请输入组件名',
	'获取下载数据失败，请刷新重试': '获取下载数据失败，请刷新重试',
	'全选': '全选',
	'设备管理': '设备管理',
	'关 闭': '关 闭',
	'未激活': '未激活',
	'家长：全部家长': '家长：全部家长',
	'现金支出合计(元)': '现金支出合计(元)',
	'此操作将解除绑定, 是否继续?': '此操作将解除绑定, 是否继续?',
	'早上消费(元)': '早上消费(元)',
	'禁用': '禁用',
	'上传文档不能大于10MB,请重新选择': '上传文档不能大于10MB,请重新选择',
	'上传成功': '上传成功',
	'小时': '小时',
	'一、批量录入人脸步骤': '一、批量录入人脸步骤',
	'适用设备': '适用设备',
	'就餐统计': '就餐统计',
	'进出设置: ': '进出设置: ',
	'单元测试': '单元测试',
	'修改直播间': '修改直播间',
	'暂无失败数据': '暂无失败数据',
	'该门禁规则不用生效的特殊日期': '该门禁规则不用生效的特殊日期',
	'期末': '期末',
	'发布时间：': '发布时间：',
	'建议尺寸：333*206，不超过1M，格式：jpg、jpeg、gif、png': '建议尺寸：333*206，不超过1M，格式：jpg、jpeg、gif、png',
	'刷脸图片': '刷脸图片',
	'所选导出数据为0条': '所选导出数据为0条',
	'服务器繁忙，请刷新重试': '服务器繁忙，请刷新重试',
	'数字': '数字',
	'学生管理': '学生管理',
	'班': '班',
	'错误详情': '错误详情',
	'系统ID': '系统ID',
	'剩余激活年限:': '剩余激活年限:',
	'下载完成': '下载完成',
	'选择设备': '选择设备',
	'请输入密码': '请输入密码',
	'配置管理': '配置管理',
	'适用人员': '适用人员',
	'切换身份': '切换身份',
	'付款数': '付款数',
	'已选择': '已选择',
	'餐次': '餐次',
	'请填写图标名称': '请填写图标名称',
	'新增公众号': '新增公众号',
	'下载人脸照片采集说明、人脸照片信息匹配表': '下载人脸照片采集说明、人脸照片信息匹配表',
	'状态': '状态',
	'添加': '添加',
	'添加家长': '添加家长',
	'最大未识别阈值不能小于等于最小识别阈值': '最大未识别阈值不能小于等于最小识别阈值',
	'失败记录': '失败记录',
	'修改身份': '修改身份',
	'请选择发布人': '请选择发布人',
	'操作': '操作',
	'添加科目失败-else, 请刷新重试': '添加科目失败-else, 请刷新重试',
	'请输入内容': '请输入内容',
	'否': '否',
	'请选择': '请选择',
	'请输入收费名称': '请输入收费名称',
	'选择时间范围': '选择时间范围',
	'就餐规则': '就餐规则',
	'现金': '现金',
	'年级班级：': '年级班级：',
	'暂无数据': '暂无数据',
	'已分账': '已分账',
	'提交内容失败-else': '提交内容失败-else',
	'规则名称最长20个字，请重新填写': '规则名称最长20个字，请重新填写',
	'固定金额': '固定金额',
	'考试班级': '考试班级',
	'撤销后，线下支付的支付信息将会清除且不能恢复，是否继续': '撤销后，线下支付的支付信息将会清除且不能恢复，是否继续',
	'商户配置修改成功': '商户配置修改成功',
	'请输入学生卡': '请输入学生卡',
	'暂不允许删除，若要删除，请先取消以下订阅': '暂不允许删除，若要删除，请先取消以下订阅',
	'选择范围：': '选择范围：',
	'账户余额': '账户余额',
	'发布': '发布',
	'选填项，选择家长': '选填项，选择家长',
	'输入模板标题，不超过40个字': '输入模板标题，不超过40个字',
	'批量订餐': '批量订餐',
	'选填项，选择职位': '选填项，选择职位',
	'识别阈值：': '识别阈值：',
	'查看结果': '查看结果',
	'周': '周',
	'本周统计': '本周统计',
	'请选择学籍状态': '请选择学籍状态',
	'收费截止时间修改成功': '收费截止时间修改成功',
	'订单号': '订单号',
	'请输入': '请输入',
	'取消': '取消',
	'按时段统计': '按时段统计',
	'取现(次)': '取现(次)',
	'规则更新成功': '规则更新成功',
	'标记': '标记',
	'自愿': '自愿',
	'手机号码*': '手机号码*',
	'搜索': '搜索',
	'全部': '全部',
	'生效时段': '生效时段',
	'已取消': '已取消',
	'姓名': '姓名',
	'代理商名称：': '代理商名称：',
	'考试班级:': '考试班级:',
	'按月统计': '按月统计',
	'收费说明：': '收费说明：',
	'闸门设备：63及其以上版本，低版本的请先升级': '闸门设备：63及其以上版本，低版本的请先升级',
	'创建日期': '创建日期',
	'修改密码': '修改密码',
	'姓名：': '姓名：',
	'时间段设置有重叠，请检查后重新保存': '时间段设置有重叠，请检查后重新保存',
	'期间的支付记录': '期间的支付记录',
	'的重复周期': '的重复周期',
	'服务管理': '服务管理',
	'操作失败,未查询到': '操作失败,未查询到',
	'消费(元)': '消费(元)',
	'全部职工': '全部职工',
	'流水记录': '流水记录',
	'删除全部门禁规则后，才允许切换': '删除全部门禁规则后，才允许切换',
	'已发布': '已发布',
	'按商户设置': '按商户设置',
	'支付宝': '支付宝',
	'请选择权限': '请选择权限',
	'模板封面': '模板封面',
	'按设备设置': '按设备设置',
	'获取年级班级列表失败, 请刷新重试': '获取年级班级列表失败, 请刷新重试',
	'卡号': '卡号',
	'项目名称': '项目名称',
	'微信单号': '微信单号',
	'请输入考试名称，不超过20个字': '请输入考试名称，不超过20个字',
	'绝对地址': '绝对地址',
	'所有': '所有',
	'金额类型': '金额类型',
	'关联公众号信息不全，请先补充完整': '关联公众号信息不全，请先补充完整',
	'商户名称': '商户名称',
	'上传填写后的人脸照片匹配表,仅支持xlsx格式': '上传填写后的人脸照片匹配表,仅支持xlsx格式',
	'个文件': '个文件',
	'批量录入速度:约每10分钟可录入60人': '批量录入速度:约每10分钟可录入60人',
	'操作失败, 请刷新重试': '操作失败, 请刷新重试',
	'同步学生数据': '同步学生数据',
	'模拟': '模拟',
	'确定催交后，系统将发送账单的推送提醒给未交费的家长用户，1天内仅能催交1次，是否继续执行': '确定催交后，系统将发送账单的推送提醒给未交费的家长用户，1天内仅能催交1次，是否继续执行',
	'上传名单(支持按单个学生设置不同收费金额)': '上传名单(支持按单个学生设置不同收费金额)',
	'提交': '提交',
	'请先选择用户类型': '请先选择用户类型',
	'功能说明': '功能说明',
	'人脸识别': '人脸识别',
	'添加规则': '添加规则',
	'请等待压缩包或匹配表文件上传完成，再进行该切换': '请等待压缩包或匹配表文件上传完成，再进行该切换',
	'未就餐人次': '未就餐人次',
	'批量录入操作': '批量录入操作',
	'毕业': '毕业',
	'请选择要搜索的学校': '请选择要搜索的学校',
	'密码': '密码',
	'学校列表': '学校列表',
	'播报名称最大长度为20个字': '播报名称最大长度为20个字',
	'获取导出数据失败, 请刷新重试': '获取导出数据失败, 请刷新重试',
	'课程链接不超过300个字': '课程链接不超过300个字',
	'模板分类': '模板分类',
	'请上传格式为zip的文件': '请上传格式为zip的文件',
	'请选择日期': '请选择日期',
	'支付金额': '支付金额',
	'排序必须为数字值': '排序必须为数字值',
	'选填项': '选填项',
	'收费项目金额不能为0，请修改': '收费项目金额不能为0，请修改',
	'收费截止时间调整为': '收费截止时间调整为',
	'该次考试存在未录入成绩的学生，请检查': '该次考试存在未录入成绩的学生，请检查',
	'选填项，选择考勤标签': '选填项，选择考勤标签',
	'代理商': '代理商',
	'主号': '主号',
	'设置消费时段': '设置消费时段',
	'设备': '设备',
	'请填写一次识别阈值': '请填写一次识别阈值',
	'家长信息': '家长信息',
	'一次识别': '一次识别',
	'模板内容': '模板内容',
	'当前账号没有权限访问此页面，请用指定账号查看': '当前账号没有权限访问此页面，请用指定账号查看',
	'学校名称': '学校名称',
	'开启': '开启',
	'组件名不能为空': '组件名不能为空',
	'已关闭': '已关闭',
	'黑名单': '黑名单',
	'商户号': '商户号',
	'已结束': '已结束',
	'成绩表': '成绩表',
	'暂无可用设备': '暂无可用设备',
	'排序': '排序',
	'前门': '前门',
	'收费对象：': '收费对象：',
	'家长总数': '家长总数',
	'请选择年级班级': '请选择年级班级',
	'知识付费': '知识付费',
	'陈小峰': '陈小峰',
	'账单已停止收费': '账单已停止收费',
	'其它设备暂不支持，请到旧版后台设置门禁规则': '其它设备暂不支持，请到旧版后台设置门禁规则',
	'男': '男',
	'个班级': '个班级',
	'是否确认删除': '是否确认删除',
	'激活费用:': '激活费用:',
	'线上支付': '线上支付',
	'识别状态': '识别状态',
	'家长管理': '家长管理',
	'时间单位': '时间单位',
	'等其他学校人脸录入完毕后,系统会自动录入该“': '等其他学校人脸录入完毕后,系统会自动录入该“',
	'添加科目': '添加科目',
	'输入照片名称、学生姓名': '输入照片名称、学生姓名',
	'时间间隔不能超过30天': '时间间隔不能超过30天',
	'校园卡信息': '校园卡信息',
	'获取学校服务收费列表接口失败': '获取学校服务收费列表接口失败',
	'早上': '早上',
	'提交内容失败-catch': '提交内容失败-catch',
	'查询时间': '查询时间',
	'退款(次)': '退款(次)',
	'收费设置': '收费设置',
	'正在删除学生,请勿重复操作!': '正在删除学生,请勿重复操作!',
	'上传的图片最大尺寸为750*319!': '上传的图片最大尺寸为750*319!',
	'上传失败，表格内容与模板格式不符，请修改后重新上传': '上传失败，表格内容与模板格式不符，请修改后重新上传',
	'是否开启分账': '是否开启分账',
	'二、采集人脸照片要求': '二、采集人脸照片要求',
	'开始日期': '开始日期',
	'确认后，该学生的账单状态将修改为“不参与”并完成账单，是否继续执行': '确认后，该学生的账单状态将修改为“不参与”并完成账单，是否继续执行',
	'添加权限': '添加权限',
	'商户配置': '商户配置',
	'延迟时间': '延迟时间',
	'导出': '导出',
	'视频文件大小不超过100M，文档文件大小不超过10M': '视频文件大小不超过100M，文档文件大小不超过10M',
	'激活': '激活',
	'孩子所属班级': '孩子所属班级',
	'分账比例': '分账比例',
	'本月充值': '本月充值',
	'正在编辑家长,请勿重复操作!': '正在编辑家长,请勿重复操作!',
	'收费名称不能为空': '收费名称不能为空',
	'权限管理': '权限管理',
	'未识别（BD2）': '未识别（BD2）',
	'播报名称：': '播报名称：',
	'课程链接': '课程链接',
	'等待中': '等待中',
	'手机主号': '手机主号',
	'手机号码：': '手机号码：',
	'结束时间': '结束时间',
	'总分分值': '总分分值',
	'原密码': '原密码',
	'身份': '身份',
	'请输入完整姓名': '请输入完整姓名',
	'账户类型': '账户类型',
	'未识别（BD1）': '未识别（BD1）',
	'确 定': '确 定',
	'请输入模板标题': '请输入模板标题',
	'收款码': '收款码',
	'校园缴费v1.2_后台_学校商户配置列表接口失败': '校园缴费v1.2_后台_学校商户配置列表接口失败',
	'所选年级中不存在班级，请先前往添加': '所选年级中不存在班级，请先前往添加',
	'更新学校收费开关接口失败': '更新学校收费开关接口失败',
	'分账商户的分账比例总和不能超过': '分账商户的分账比例总和不能超过',
	'常规账户': '常规账户',
	'去选择': '去选择',
	'收款码名称': '收款码名称',
	'商户': '商户',
	'未支付': '未支付',
	'账单详情': '账单详情',
	'通知内容：': '通知内容：',
	'最小脸部：': '最小脸部：',
	'人脸库同步': '人脸库同步',
	'选择分类': '选择分类',
	'请上传人脸照片压缩包': '请上传人脸照片压缩包',
	'性别：': '性别：',
	'长度最多为 24 个字符': '长度最多为 24 个字符',
	'照片': '照片',
	'课程名称不超过30个字': '课程名称不超过30个字',
	'全部学生': '全部学生',
	'日期': '日期',
	'只出不进': '只出不进',
	'已成功上传该附件': '已成功上传该附件',
	'无': '无',
	'请选择是否为导航菜单': '请选择是否为导航菜单',
	'订餐人数': '订餐人数',
	'日': '日',
	'发布成功': '发布成功',
	'收费名称：': '收费名称：',
	'请选择要添加考试的学校': '请选择要添加考试的学校',
	'消费合计(元)': '消费合计(元)',
	'已交费': '已交费',
	'产品管理': '产品管理',
	'未知': '未知',
	'预计还需': '预计还需',
	'微信': '微信',
	'创建时间': '创建时间',
	'门禁动作': '门禁动作',
	'请输入商户号': '请输入商户号',
	'下载失败记录': '下载失败记录',
	'按日期统计': '按日期统计',
	'一': '一',
	'人脸识别闸门1代：支持全部版本': '人脸识别闸门1代：支持全部版本',
	'人脸录入完毕后,系统会自动录入该“': '人脸录入完毕后,系统会自动录入该“',
	'请搜索角色名称': '请搜索角色名称',
	'输入关键字进行过滤': '输入关键字进行过滤',
	'三': '三',
	'描述': '描述',
	'人脸识别闸门2代：91及其以上版本，低版本的请先升级': '人脸识别闸门2代：91及其以上版本，低版本的请先升级',
	'请填写模板内容': '请填写模板内容',
	'校园缴费v1.2_后台_分账关系列表接口失败': '校园缴费v1.2_后台_分账关系列表接口失败',
	'同步结果': '同步结果',
	'附件：': '附件：',
	'未识别（TX1）': '未识别（TX1）',
	'暂无年级数据': '暂无年级数据',
	'请先选择代理商或者学校': '请先选择代理商或者学校',
	'通知标题：': '通知标题：',
	'选择名单': '选择名单',
	'创建收款码': '创建收款码',
	'宿舍': '宿舍',
	'不需要统计的设备': '不需要统计的设备',
	'老师': '老师',
	'选择文件失败,请刷新重试': '选择文件失败,请刷新重试',
	'个': '个',
	'相似度': '相似度',
	'未识别相似度': '未识别相似度',
	'路由配置': '路由配置',
	'二次识别活体阈值': '二次识别活体阈值',
	'是': '是',
	'请输入收款码名称': '请输入收款码名称',
	'请输入正确的手机号': '请输入正确的手机号',
	'未交费': '未交费',
	'只进不出': '只进不出',
	'正在上传，请勿重复点击': '正在上传，请勿重复点击',
	'学生姓名：': '学生姓名：',
	'一次只能上传一个zip文件，请删除再上传': '一次只能上传一个zip文件，请删除再上传',
	'对象范围不能为空': '对象范围不能为空',
	'收费项目：': '收费项目：',
	'相似人': '相似人',
	'温馨提示：若是开启人脸收费业务的学校，请先确认学生的剩余可用人脸数量。': '温馨提示：若是开启人脸收费业务的学校，请先确认学生的剩余可用人脸数量。',
	'点击上传': '点击上传',
	'开始时间': '开始时间',
	'删除成功': '删除成功',
	'现金统计': '现金统计',
	'请填写规则名称': '请填写规则名称',
	'账单状态': '账单状态',
	'操作人员': '操作人员',
	'激活时长:': '激活时长:',
	'不超过50个字': '不超过50个字',
	'开通会员': '开通会员',
	'批量配置': '批量配置',
	'进行中': '进行中',
	'录入失败': '录入失败',
	'最小识别阈值不能为0': '最小识别阈值不能为0',
	'请添加模板背景': '请添加模板背景',
	'科目？': '科目？',
	'研发中': '研发中',
	'其它设备暂不支持': '其它设备暂不支持',
	'日常运营管理': '日常运营管理',
	'用户填写': '用户填写',
	'挂失': '挂失',
	'该考试你已经发布过, 不能再发布': '该考试你已经发布过, 不能再发布',
	'下午消费(元)': '下午消费(元)',
	'关闭所有': '关闭所有',
	'修改权限': '修改权限',
	'上传的图片最大尺寸为333*206!': '上传的图片最大尺寸为333*206!',
	'考试类型': '考试类型',
	'选择一次识别算法': '选择一次识别算法',
	'登记信息不全，请先补充完整': '登记信息不全，请先补充完整',
	'学生': '学生',
	'年': '年',
	'周日': '周日',
	'请输入课程链接': '请输入课程链接',
	'批量': '批量',
	'休学': '休学',
	'消费收支结余(元)': '消费收支结余(元)',
	'必填项': '必填项',
	'下载表格': '下载表格',
	'发布范围：': '发布范围：',
	'取 消': '取 消',
	'本月统计': '本月统计',
	'已截止': '已截止',
	'二': '二',
	'支付方式': '支付方式',
	'停止': '停止',
	'请输入标题（不超过 24 个字符）': '请输入标题（不超过 24 个字符）',
	'设备类型：': '设备类型：',
	'请输入关键词': '请输入关键词',
	'周一': '周一',
	'取现(元)': '取现(元)',
	'下午': '下午',
	'五': '五',
	'设置方式': '设置方式',
	'上传文件失败': '上传文件失败',
	'请输入标题，不超过50个字': '请输入标题，不超过50个字',
	'选择文件：': '选择文件：',
	'创建平台': '创建平台',
	'选择班级': '选择班级',
	'请添加背景颜色': '请添加背景颜色',
	'请稍后重试': '请稍后重试',
	'学生：': '学生：',
	'周三': '周三',
	'若为“必交”则默认勾选，且不可取消勾选，家长必须支付此项；若为“选交”，则家长可自由勾选并支付': '若为“必交”则默认勾选，且不可取消勾选，家长必须支付此项；若为“选交”，则家长可自由勾选并支付',
	'二次识别': '二次识别',
	'时间': '时间',
	'请输入完整相似度值': '请输入完整相似度值',
	'行数': '行数',
	'已取消删除': '已取消删除',
	'文档不能大于1MB,请重新选择': '文档不能大于1MB,请重新选择',
	'分钟,请耐心等待': '分钟,请耐心等待',
	'年级': '年级',
	'人': '人',
	'全部设备': '全部设备',
	'正在下载数据': '正在下载数据',
	'三次次识别活体阈值': '三次次识别活体阈值',
	'拼命加载中': '拼命加载中',
	'正在添加学生卡,请勿重复操作!': '正在添加学生卡,请勿重复操作!',
	'请选择模板分类': '请选择模板分类',
	'危险区域': '危险区域',
	'启用': '启用',
	'成绩': '成绩',
	'就餐人次': '就餐人次',
	'即可': '即可',
	'权限配置': '权限配置',
	'家长：': '家长：',
	'四': '四',
	'确定后系统将执行同步': '确定后系统将执行同步',
	'该学校还没添加任何职工': '该学校还没添加任何职工',
	'正在请求数据': '正在请求数据',
	'是否默认背景': '是否默认背景',
	'人脸闸门暂停更新数据时段': '人脸闸门暂停更新数据时段',
	'课程简介不超过30个字': '课程简介不超过30个字',
	'请求规则默认设置': '请求规则默认设置',
	'条数据同步失败': '条数据同步失败',
	'导航菜单': '导航菜单',
	'数据正在导入中，请不要离开当前页面': '数据正在导入中，请不要离开当前页面',
	'不需要统计的商户': '不需要统计的商户',
	'分账状态修改失败': '分账状态修改失败',
	'生日：': '生日：',
	'结束日期': '结束日期',
	'亲属关系：': '亲属关系：',
	'手机号': '手机号',
	'请求规则列表': '请求规则列表',
	'仅支持jpg、jpeg、gif、png件的上传,请重新选择': '仅支持jpg、jpeg、gif、png件的上传,请重新选择',
	'二次识别活体阈值不能为0': '二次识别活体阈值不能为0',
	'下载人脸照片匹配表': '下载人脸照片匹配表',
	'开': '开',
	'支付宝代扣': '支付宝代扣',
	'收费项目信息不全，请先补充完整': '收费项目信息不全，请先补充完整',
	'到期时间': '到期时间',
	'人脸照片采集说明.docx': '人脸照片采集说明.docx',
	'收起': '收起',
	'保存': '保存',
	'截止时间：': '截止时间：',
	'职工': '职工',
	'正在上传': '正在上传',
	'创建人': '创建人',
	'请等待匹配表文件上传完成，再进行该切换': '请等待匹配表文件上传完成，再进行该切换',
	'新密码': '新密码',
	'周五': '周五',
	'学生姓名*': '学生姓名*',
	'请填写门禁规则的结束日期或设置为永久生效': '请填写门禁规则的结束日期或设置为永久生效',
	'请输入最小识别阈值': '请输入最小识别阈值',
	'程序错误，请稍后再试': '程序错误，请稍后再试',
	'周二': '周二',
	'上传人脸照片匹配表': '上传人脸照片匹配表',
	'优惠券链接': '优惠券链接',
	'支付时间': '支付时间',
	'关闭其他': '关闭其他',
	'商户名称：': '商户名称：',
	'按商户统计': '按商户统计',
	'不额外放行请假用户': '不额外放行请假用户',
	'手机号码': '手机号码',
	'更新资料': '更新资料',
	'添加门禁动作': '添加门禁动作',
	'商户号：': '商户号：',
	'录入结果': '录入结果',
	'已录入': '已录入',
	'重置': '重置',
	'待分账': '待分账',
	'若为“必交”则默认勾选，且不可取消勾选，家长必须支付此项；若为“选交”，则家长可自由勾选并支付。最多可添加10个收费项目': '若为“必交”则默认勾选，且不可取消勾选，家长必须支付此项；若为“选交”，则家长可自由勾选并支付。最多可添加10个收费项目',
	'单选': '单选',
	'权限': '权限',
	'条': '条',
	'退卡(次)': '退卡(次)',
	'人脸照片匹配表(家长)': '人脸照片匹配表(家长)',
	'路径': '路径',
	'请输入课程名称': '请输入课程名称',
	'提示': '提示',
	'幼儿园刷卡机：160及其以上版本，低版本的请先升级': '幼儿园刷卡机：160及其以上版本，低版本的请先升级',
	'当前所属商户': '当前所属商户',
	'退款(元)': '退款(元)',
	'请刷新重试': '请刷新重试',
	'请选择学生性别': '请选择学生性别',
	'必交': '必交',
	'监听': '监听',
	'人脸照片匹配表(学生)': '人脸照片匹配表(学生)',
	'周四': '周四',
	'请填写门禁动作': '请填写门禁动作',
	'请选择考试类型': '请选择考试类型',
	'现金收支结余(元)': '现金收支结余(元)',
	'就餐状态': '就餐状态',
	'选择学校': '选择学校',
	'保密': '保密',
	'地点': '地点',
	'已激活': '已激活',
	'支付': '支付',
	'进出设置': '进出设置',
	'学生总数:': '学生总数:',
	'抓拍照片': '抓拍照片',
	'默认允许所有人进出': '默认允许所有人进出',
	'学生标识：': '学生标识：',
	'家长手机号': '家长手机号',
	'展示': '展示',
	'未添加收费项目，请先添加后提交': '未添加收费项目，请先添加后提交',
	'现金支出统计': '现金支出统计',
	'正在下载': '正在下载',
	'获取编辑的内容失败': '获取编辑的内容失败',
	'默认禁止所有人进出': '默认禁止所有人进出',
	'全部状态': '全部状态',
	'请假用户将允许在设置的时段内被放行': '请假用户将允许在设置的时段内被放行',
	'选交': '选交',
	'录入成功': '录入成功',
	'学校人数': '学校人数',
	'永久生效': '永久生效',
	'输入照片名称、职工姓名': '输入照片名称、职工姓名',
	'添加考试失败, 请重试': '添加考试失败, 请重试',
	'请输入后台地址': '请输入后台地址',
	'今日已发起过催交提醒，请明天再执行催交操作': '今日已发起过催交提醒，请明天再执行催交操作',
	'收费项目': '收费项目',
	'账户管理': '账户管理',
	'人员去重': '人员去重',
	'请重试': '请重试',
	'交费规则：': '交费规则：',
	'输入照片名称、孩子所属姓名': '输入照片名称、孩子所属姓名',
	'充值(元)': '充值(元)',
	'消费合计(次)': '消费合计(次)',
	'人脸库图片': '人脸库图片',
	'取消激活学校收费接口失败': '取消激活学校收费接口失败',
	'访客': '访客',
	'配置': '配置',
	'建议尺寸：750*319，不超过1M，格式：jpg、jpeg、gif、png': '建议尺寸：750*319，不超过1M，格式：jpg、jpeg、gif、png',
	'该学校暂无识别记录！': '该学校暂无识别记录！',
	'数据加载中': '数据加载中',
	'当前表格有': '当前表格有',
	'实验室': '实验室',
	'校园缴费v1.2_后台_获取分账默认设置接口失败': '校园缴费v1.2_后台_获取分账默认设置接口失败',
	'产品运营': '产品运营',
	'请输入最大识别阈值': '请输入最大识别阈值',
	'正在提交...': '正在提交...',
	'百度': '百度',
	'测试': '测试',
	'请等待压缩包文件上传完成，再进行该切换': '请等待压缩包文件上传完成，再进行该切换',
	'全屏': '全屏',
	'规则开始日期': '规则开始日期',
	'登记信息': '登记信息',
	'二次识别阈值': '二次识别阈值',
	'不超过15个字': '不超过15个字',
	'角色管理': '角色管理',
	'账单已开启收费': '账单已开启收费',
	'请选择渠道': '请选择渠道',
	'请先选择渠道': '请先选择渠道',
	'选择渠道': '选择渠道',
	'选择代理商': '选择代理商',
	'所有渠道': '所有渠道',
	'所有代理商': '所有代理商',
	'请选择代理商': '请选择代理商',
	'所有学校': '所有学校',
	'1、选择“用户类型”': '1、选择“用户类型”',
	'2、下载“采集人脸照片要求、人脸照片信息匹配表”。': '2、下载“采集人脸照片要求、人脸照片信息匹配表”。',
	'3、按要求采集人脸照片，打成zip压缩包，上传到后台。': '3、按要求采集人脸照片，打成zip压缩包，上传到后台。',
	'4、在人脸照片匹配表填写“照片名称”后,上传到后台。': '4、在人脸照片匹配表填写“照片名称”后,上传到后台。',
	'5、点击“确定”按钮，开始批量导入。': '5、点击“确定”按钮，开始批量导入。',
	'1、照片格式要求': '1、照片格式要求',
	'●照片名称不要带有空格，最长不要超过40个字,如“小明”。': '●照片名称不要带有空格，最长不要超过40个字,如“小明”。',
	'●照片支持jpg. jpeg. png格式， 要求不小于800*800像素。': '●照片支持jpg. jpeg. png格式， 要求不小于800*800像素。',
	'2、拍摄场景要求': '2、拍摄场景要求',
	'●干净纯色的照片背景为佳，推荐使用纯白色背景。(近肤色的背景除外)': '●干净纯色的照片背景为佳，推荐使用纯白色背景。(近肤色的背景除外)',
	'●不要在逆光、强光、阴暗的环境拍摄照片，不要二次翻拍已有的人脸照片。': '●不要在逆光、强光、阴暗的环境拍摄照片，不要二次翻拍已有的人脸照片。',
	'●被拍摄者需要平视镜头，不准低头歪头，眼睛眉毛需要清晰可见，头发不准遮挡到眉毛。': '●被拍摄者需要平视镜头，不准低头歪头，眼睛眉毛需要清晰可见，头发不准遮挡到眉毛。',
	'3、打压缩包要求': '3、打压缩包要求',
	'●将采集的照片,全部放在1个文件夹里,打包成zip压缩包': '●将采集的照片,全部放在1个文件夹里,打包成zip压缩包',
	'1、请填写学生所属的“照片名称”即可。(如“小明”，不用填写文件拓展名)': '1、请填写学生所属的“照片名称”即可。(如“小明”，不用填写文件拓展名)',
	'2、请勿修改表格模板已有的信息和格式。': '2、请勿修改表格模板已有的信息和格式。',
	'3、对于已录入照片的用户，重新录入的话，新照片将会覆盖旧照片。': '3、对于已录入照片的用户，重新录入的话，新照片将会覆盖旧照片。',
	'①请填写家长所属的“照片名称”即可。(如“李妈妈”，不用填写文件拓展名)': '①请填写家长所属的“照片名称”即可。(如“李妈妈”，不用填写文件拓展名)',
	'①请填写学生所属的“照片名称”即可。(如“小明”，不用填写文件拓展名)': '①请填写学生所属的“照片名称”即可。(如“小明”，不用填写文件拓展名)',
	'②请勿修改表格模板格式。': '②请勿修改表格模板格式。',
	'③填写表格时， 请勿修改“系统ID、孩子所属年级、孩子所属班级、孩子姓名、家长手机号”。': '③填写表格时， 请勿修改“系统ID、孩子所属年级、孩子所属班级、孩子姓名、家长手机号”。',
	'④对于已录入照片的家长，重新录入的话，新照片将会覆盖旧照片。': '④对于已录入照片的家长，重新录入的话，新照片将会覆盖旧照片。',
	'①请填写职工所属的“照片名称”即可。(如“王校长”，不用填写文件拓展名)': '①请填写职工所属的“照片名称”即可。(如“王校长”，不用填写文件拓展名)',
	'③填写表格时， 请勿修改“系统ID、手机号、职工姓名”。': '③填写表格时， 请勿修改“系统ID、手机号、职工姓名”。',
	'④对于已录入照片的职工，重新录入的话，新照片将会覆盖旧照片。': '④对于已录入照片的职工，重新录入的话，新照片将会覆盖旧照片。',
	'请先选择年级': '请先选择年级',
	'请选择年级': '请选择年级',
	'该学校暂未划分年级': '该学校暂未划分年级',
	'获取年级列表失败请刷新重试': '获取年级列表失败请刷新重试',
	'获取年级列表失败, 请刷新重试': '获取年级列表失败, 请刷新重试',
	'获取班级列表失败请刷新重试': '获取班级列表失败请刷新重试',
	'获取班级列表失败, 请刷新重试': '获取班级列表失败, 请刷新重试',
	'+添加模板': '+添加模板',
	'默认': '默认',
	'[坏笑]': '[坏笑]',
	'[舔屏]': '[舔屏]',
	'成绩管理' : '成绩管理',
	'通知模板' : '通知模版',
	'【家长】仅针对带人脸识别功能的设备有效，其他设备可以不用设置' : '【家长】仅针对带人脸识别功能的设备有效，其他设备可以不用设置',
	'月': '月',
	'批量录入人脸': '批量录入人脸',
	'学校商户配置': '学校商户配置',
	'清除': '清除',
	'1、当前支持的设备': '1、当前支持的设备',
	'2、其他设备': '2、其他设备',
	'"学生、职工、家长"中的3个筛选项，请至少选填1项': '"学生、职工、家长"中的3个筛选项，请至少选填1项',
	'③填写表格时， 请勿修改“系统ID、手机主号、年级、班级、学生姓名”。': '③填写表格时， 请勿修改“系统ID、手机主号、年级、班级、学生姓名”。',
	'④对于已录入照片的学生，重新录入的话，新照片将会覆盖旧照片。': '④对于已录入照片的学生，重新录入的话，新照片将会覆盖旧照片。',
	'选择的用户类型或上传的人脸照片匹配表有误': '选择的用户类型或上传的人脸照片匹配表有误',
	'健康管理': '健康管理',
	'健康日报': '健康日报',
	'选择时段': '选择时段',
	'角色类型': '角色类型',
	'选择状态': '选择状态',
	'正常': '正常',
	'异常': '异常',
	'职位': '职位',
	'测温时段': '测温时段',
	'温度': '温度',
	'获取老师体温列表失败, 请刷新重试': '获取老师体温列表失败, 请刷新重试',
	'获取学生体温列表失败, 请刷新重试': '获取学生体温列表失败, 请刷新重试',
	'获取时段列表失败, 请刷新重试': '获取时段列表失败, 请刷新重试',
	', 请刷新重试':', 请刷新重试',
	',请重新导出': ',请重新导出',
	'未填写照片名称，默认不进行任何处理': '未填写照片名称，默认不进行任何处理',
	'用户人脸已经存在，请先删除再上传': '用户人脸已经存在，请先删除再上传',
	'使用帮助' : '使用帮助',
	'帮助详情' : '帮助详情',
	'职工ID': '职工ID',
	'已经有任务正在进行': '已经有任务正在进行',
	'当前表格为空': '当前表格为空',
	'下载人脸照片采集说明地址': 'https://xbull.oss-cn-shenzhen.aliyuncs.com/app_agreement/%E4%BA%BA%E8%84%B8%E7%85%A7%E7%89%87%E9%87%87%E9%9B%86%E8%AF%B4%E6%98%8E.docx',
	'请求错误': '请求错误',
	'服务器内部错误，请联系管理员': '服务器内部错误，请联系管理员',
	'登录已过期， 请重新登陆': '登录已过期， 请重新登陆',
	'请求失败,请刷新重试': '请求失败,请刷新重试',
	'请勿重复设置，门禁规则“': '请勿重复设置，门禁规则“',
	'”已经设置过': '”已经设置过',
	'的家长': '的家长',
};
